/**
 * LIVE ICA "Results & Filings" subcategories.
 *
 * These five announcement types reach every user regardless of watchlist, and
 * users can switch them off with the Results & Filings toggle.
 *
 * `value` is the string stored on the announcement and must match the backend's
 * LIVE_ANNOUNCEMENT_PUBLIC_SUBCATEGORIES setting exactly, typos included -- the
 * ingest writes those literals. `label` is what we show people. Never print the
 * raw value.
 */
export const RESULTS_FILINGS_SUBCATEGORIES = [
  { value: 'Investor Presentation', label: 'Investor Presentation' },
  { value: 'Earning Call Transcript', label: 'Earnings Call Transcript' },
  { value: 'Reg. 53 Anual Reports', label: 'Annual Reports (Reg. 53)' },
  { value: 'Reg. 52 Financial Result', label: 'Financial Results (Reg. 52)' },
  { value: 'Outcome of Board Meeting', label: 'Outcome of Board Meeting' },
];

export const RESULTS_FILINGS_LABELS = RESULTS_FILINGS_SUBCATEGORIES.map((item) => item.label);

const RESULTS_FILINGS_VALUES = new Set(
  RESULTS_FILINGS_SUBCATEGORIES.map((item) => item.value)
);

/** Whether an announcement belongs to the Results & Filings group. */
export const isResultsFilingsAnnouncement = (announcement) =>
  RESULTS_FILINGS_VALUES.has((announcement?.subcategory_name || '').trim());
